import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { LOGO_URL } from "@/lib/brand";

const SPARKS = Array.from({ length: 10 }, (_, i) => i);

export default function Splash() {
  const nav = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => { const next = sessionStorage.getItem("pz_after_login"); sessionStorage.removeItem("pz_after_login"); nav(next || "/home", { replace: true }); }, 3000);
    return () => clearTimeout(t);
  }, [nav]);

  const mask = { WebkitMaskImage: `url(${LOGO_URL})`, maskImage: `url(${LOGO_URL})`, WebkitMaskSize: "100% 100%", maskSize: "100% 100%" };

  return (
    <div className="min-h-screen pz-radial flex flex-col items-center justify-center overflow-hidden" data-testid="splash-screen">
      <motion.div className="absolute left-0 right-0 h-px bg-gradient-to-r from-transparent via-pazer-red to-transparent"
        style={{ top: "calc(50% + 6.5rem)", boxShadow: "0 0 18px 2px rgba(245,208,66,0.7)" }}
        initial={{ scaleX: 0, opacity: 0 }} animate={{ scaleX: [0, 1, 1], opacity: [0, 1, 0.25] }}
        transition={{ duration: 1.6, times: [0, 0.4, 1], ease: "easeOut" }} />

      <motion.div className="relative w-[28rem] max-w-[82vw] pz-logo" data-testid="splash-logo-wrap"
        initial={{ scale: 0.92 }} animate={{ scale: [0.92, 1, 1.04, 1] }} transition={{ duration: 2.4, times: [0, 0.45, 0.75, 1] }}>
        <motion.img src={LOGO_URL} alt="LaserTime.live" className="block w-full h-auto" data-testid="splash-logo"
          initial={{ clipPath: "inset(0 100% 0 0)" }} animate={{ clipPath: "inset(0 0% 0 0)" }}
          transition={{ delay: 0.3, duration: 0.9, ease: [0.65, 0, 0.35, 1] }} />

        <motion.div className="absolute -top-6 -bottom-6 w-[3px] rounded-full bg-white pointer-events-none" data-testid="splash-laser"
          style={{ boxShadow: "0 0 12px 3px #F5D042, 0 0 40px 10px rgba(245,208,66,0.6)" }}
          initial={{ left: "0%", opacity: 0 }} animate={{ left: ["0%", "100%"], opacity: [0, 1, 1, 0] }}
          transition={{ delay: 0.3, duration: 0.9, ease: [0.65, 0, 0.35, 1], opacity: { delay: 0.3, duration: 1, times: [0, 0.1, 0.85, 1] } }} />

        <div className="absolute inset-0 pointer-events-none overflow-hidden" style={mask} data-testid="splash-shine">
          <span className="pz-logo-shine" />
        </div>

        {SPARKS.map((i) => (
          <motion.span key={i} className="absolute h-1 w-1 rounded-full bg-pazer-red pointer-events-none"
            style={{ left: "100%", top: `${20 + (i * 7) % 60}%`, boxShadow: "0 0 6px #F5D042" }}
            initial={{ opacity: 0, x: 0, y: 0 }}
            animate={{ opacity: [0, 1, 0], x: 30 + (i % 4) * 18, y: (i % 2 ? -1 : 1) * (10 + (i * 9) % 40) }}
            transition={{ delay: 1.15 + i * 0.02, duration: 0.6, ease: "easeOut" }} />
        ))}
      </motion.div>

      <motion.p initial={{ opacity: 0, letterSpacing: "0.1em" }} animate={{ opacity: 1, letterSpacing: "0.35em" }} transition={{ delay: 1.6, duration: 0.8 }}
        className="mt-10 font-mono-pz text-sm uppercase text-white/60" data-testid="splash-tagline">
        Master Your Timing
      </motion.p>
    </div>
  );
}
